/* global ParamsData */

import Popin from './popin';

export default secretary => {
    // console.log('secretary');
    const popinSecretary = document.querySelector('#popin-secretary');
    const imgContainer = popinSecretary.querySelector('.img-container');
    const textContainer = popinSecretary.querySelector('.text-container');
    // const dataSecretaryInfoFields = popinSecretary.querySelectorAll('[data-secretary-info]');
    // const skeletonClasses = popinSecretary.querySelectorAll('.skeleton');

    function showSecretary(content) {
        let htmlInfos = '';

        if (content.image_url) {
            imgContainer.innerHTML = `
                <img src="${content.image_url}" alt="${content.image_alt}" loading="lazy">
            `;
        } else {
            imgContainer.classList.add('placeholder');
            imgContainer.innerHTML = `
                <img src="${ParamsData.wp_theme_url}assets/img/placeholder.svg" alt="" loading="lazy">
                <span>Pas de photo</span>
            `;
        }

        if (content.rank) {
            htmlInfos += `
                <div class="secretary-rank">${content.rank}</div>
            `;
        }

        if (content.name) {
            htmlInfos += `
                <div class="secretary-name">${content.name}</div>
            `;
        }

        if (content.mission) {
            htmlInfos += `
                <div class="secretary-mission">${content.mission}</div>
            `;
        }

        if (content.promotion) {
            htmlInfos += `
                <div class="secretary-promotion tag la-conference">${content.promotion}</div>
            `;
        }

        if (content.description) {
            htmlInfos += `
                <div class="secretary-description">
                    <hr>
                    <div class="title">À propos de</div>
                    <p>${content.description}</p>
                </div>
            `;
        }

        htmlInfos += `
            <ul class="infos">
        `;

        if (content.address) {
            htmlInfos += `
                <li class="info icon-home">
                    <div class="info-title">Adresse</div>
                    <div class="info-text">
                        <p><a href="https://www.google.com/maps/place/${content.address}" target="_blank" rel="noopener">${content.address}</a></p>
                    </div>
                </li>
            `;
        }

        if (content.email) {
            htmlInfos += `
                <li class="info icon-email">
                    <div class="info-title">Email</div>
                    <div class="info-text">
                        <p><a href="mailto:${content.email}">${content.email}</a></p>
                    </div>
                </li>
            `;
        }

        if (content.phone) {
            htmlInfos += `
                <li class="info icon-phone">
                    <div class="info-title">Téléphone</div>
                    <div class="info-text">
                        <p><a href="tel:${content.phone}">${content.phone}</a></p>
                    </div>
                </li>
            `;
        }

        if (content.fax) {
            htmlInfos += `
                <li class="info icon-printer">
                    <div class="info-title">Fax</div>
                    <div class="info-text">
                        <p>${content.fax}</p>
                    </div>
                </li>
            `;
        }

        if (content.languages) {
            htmlInfos += `
                <li class="info icon-world">
                    <div class="info-title">Langues</div>
                    <div class="info-text">
                        <p>${content.languages}</p>
                    </div>
                </li>
            `;
        }

        if (content.toque) {
            htmlInfos += `
                <li class="info icon-hat">
                    <div class="info-title">Toque</div>
                    <div class="info-text">
                        <p>${content.toque}</p>
                    </div>
                </li>
            `;
        }

        if (content.batonnier) {
            htmlInfos += `
                <li class="info icon-hat">
                    <div class="info-title">Batonnier</div>
                    <div class="info-text">
                        <p>${content.batonnier}</p>
                    </div>
                </li>
            `;
        }

        htmlInfos += `
            </ul>
        `;

        if (htmlInfos !== '') {
            textContainer.innerHTML = htmlInfos;
        }
    }

    function sendAjax(btn) {
        const request = new XMLHttpRequest();
        const url = ParamsData.wp_ajax_url;
        const ajaxData = new FormData();

        ajaxData.append('action', 'get_secretaire');
        ajaxData.append('nonce', ParamsData.nonce);
        ajaxData.append('id', btn.dataset.secretary);

        request.open('POST', url, true);

        request.send(ajaxData);

        request.onprogress = () => {
            // console.log('onprogress...');
        };

        request.onload = () => {
            let response = request.response;

            if (typeof response === 'string') {
                response = JSON.parse(response);
            }

            // console.log(response);

            switch (response.status) {
                case 200:
                    showSecretary(response.content);
                    break;

                default:
                    break;
            }
        };

        request.onerror = () => {
            // console.log('onerror...');
        };
    }

    secretary.querySelectorAll('.open-popin').forEach(btn => {
        btn.addEventListener('click', event => {
            event.preventDefault();

            new Popin({
                id: btn.dataset.popin,
                beforeOpen() {
                    // sendAjax(btn);
                },
                afterOpen() {
                    sendAjax(btn);
                },
                afterClose() {
                    imgContainer.innerHTML = '';
                    imgContainer.classList.remove('placeholder');
                    textContainer.innerHTML = '';
                },
            });
        });
    });
};
